import { rootApi } from "../../api/rootApi";

export const userLogsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchUserLogsData: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/user-logs${
                        params?.query
                            ? `?${new URLSearchParams(
                                  params?.query
                              ).toString()}`
                            : ""
                    }`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                };
            },
        }),
        exportUserLogsData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/user-logs/export`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params?.body || {},
                };
            },
        }),
    }),
});

export const { useFetchUserLogsDataMutation, useExportUserLogsDataMutation } =
    userLogsApi;
